import FlexPane from './_flex-pane.js'
import AnimatedButton from './_animated-button.js'
import Text from './_text.js'
import Hideable from './_hideable.js'

export default {
  name: 'PlaceBetButton',
  values: {
    showTotalStake: false,
    placeBetButtonContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 1,
          width: '100%',
        },
      },
    },
    buttonStyle: {
      configSet: AnimatedButton,
      configValues: {
        childrenContainer: {
          style: {
            flexDirection: 'column',
            padding: '4px',
            boxSizing: 'border-box',
          },
        },
      },
    },
    textContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexGrow: 0,
          textAlign: 'center',
        },
      },
    },
    buttonText: {
      configSet: Text,
      configValues: {
        truncate: true,
        ellipsisOnLineNumber: 1,
        container: {
          flexShrink: 1,
          flexGrow: 0,
        },
      },
    },
    totalStakeText: {
      configSet: Text,
      configValues: {
        truncate: false,
      },
    },
    disabledText: {
      configSet: Text,
      configValues: {},
    },
    potentialReturns: {
      configSet: Text,
      configValues: {
        truncate: true,
        ellipsisOnLineNumber: 1,
        style: {
          textAlign: 'center',
        },
        container: {
          whiteSpace: 'nowrap',
          flexShrink: 1,
          flexGrow: 0,
        },
      },
    },
    potentialReturnValue: {
      configSet: Text,
      configValues: {
        truncate: false,
        container: {
          flexGrow: 0,
        },
      },
    },
    buttonVisibility: {
      hide: false,
      $mixin: [
        {
          configSet: Hideable,
        },
      ],
    },
  },
  meta: {
    extendable: false,
  },
}
